<template>
  <el-dialog title="设置显示列名" :visible.sync="dialog" width="560px" class="set-table-header">
    <el-checkbox-group v-model="checkList" class="field-label">
      <template v-for="item in nativeTableHeader">
        <el-checkbox
          :checked="!item.isHide"
          :label="item.value"
          v-if="item.value !== 'action' && item.name"
          :key="item.value"
          >{{ item.name }}</el-checkbox
        >
      </template>
    </el-checkbox-group>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="setShowField">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { CheckboxGroup, Checkbox, Dialog } from 'element-ui';
import localCache from '@/utils/localCache';

export default {
  name: 'SetTableHeader',
  props: {
    tableHeader: {
      type: Array,
      required: true,
      default: () => []
    },
    dialogVisible: {
      type: Boolean,
      required: true,
      default: () => false
    },
    itemKey: {
      type: String,
      required: true
    }
  },
  components: {
    ElDialog: Dialog,
    ElCheckboxGroup: CheckboxGroup,
    ElCheckbox: Checkbox
  },
  data() {
    return {
      checkList: [],
      nativeTableHeader: this.tableHeader
    };
  },
  watch: {
    tableHeader() {
      if (
        this.tableHeader.length !== this.nativeTableHeader.length
        || JSON.stringify(this.nativeTableHeader) !== JSON.stringify(this.tableHeader)
      ) {
        this.init();
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.dialogVisible;
      },
      set() {
        this.$emit('close');
      }
    }
  },
  methods: {
    init() {
      const header = localCache.getItem(this.itemKey);
      if (header && header.length) {
        if (
          this.tableHeader.length
          && (header.length !== this.tableHeader.length
          || this.tableHeader.find((item, index) => item.value !== header[index].value))
        ) {
          this.$message.info('表格列名更新，现已恢复至初始值，需重新设置！');
          this.nativeTableHeader = this.tableHeader;
          localCache.removeItem(this.itemKey);
        } else {
          this.nativeTableHeader = header;
        }
      } else {
        this.nativeTableHeader = this.tableHeader;
      }
      this.$emit('change', this.nativeTableHeader);
    },
    setShowField() {
      this.nativeTableHeader = this.tableHeader.map(item => {
        const temp = { ...item };
        if (this.checkList.indexOf(item.value) === -1 && temp.value !== 'action') {
          temp.isHide = true;
        } else {
          temp.isHide = false;
        }
        return temp;
      });
      // 存储用户定义字段
      localCache.setItem(this.itemKey, this.nativeTableHeader);
      this.$emit('change', this.nativeTableHeader);
      this.$emit('close');
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="less">
.set-table-header {
  .el-checkbox {
    min-width: 100px;
    margin-bottom: 15px;
  }
}
</style>
